"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/ViewProperty
 */

/**
 * @enum {string}
 */
var _default = {
  CENTER: 'center',
  RESOLUTION: 'resolution',
  ROTATION: 'rotation'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7OztlQUdlO0VBQ2JBLE1BQU0sRUFBRSxRQURLO0VBRWJDLFVBQVUsRUFBRSxZQUZDO0VBR2JDLFFBQVEsRUFBRTtBQUhHLEMiLCJuYW1lcyI6WyJDRU5URVIiLCJSRVNPTFVUSU9OIiwiUk9UQVRJT04iXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3JjL1ZpZXdQcm9wZXJ0eS5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==